var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增合伙人",
            visible: _vm.dialog.visible,
            "append-to-body": "",
            "modal-append-to-body": false,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
            closed: _vm.beforeClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.params,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "公司名称：", prop: "companyId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { placeholder: "所属公司", clearable: "" },
                      model: {
                        value: _vm.params.companyId,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "companyId", $$v)
                        },
                        expression: "params.companyId",
                      },
                    },
                    _vm._l(_vm.companyList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.companyName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机号：", prop: "partnerPhoneNums" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 99 },
                      maxlength: "999",
                      "show-word-limit": "",
                      placeholder: "多个手机号,隔开",
                    },
                    model: {
                      value: _vm.params.partnerPhoneNums,
                      callback: function ($$v) {
                        _vm.$set(_vm.params, "partnerPhoneNums", $$v)
                      },
                      expression: "params.partnerPhoneNums",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { staticStyle: {}, attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.hide } }, [_vm._v("取 消")]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }